import { useWealthSavingsSectionContent } from './useWealthSavingsSectionContent';
import { parseWealthSavingsHowToGetStartedContent } from '../utils/wealthSavingsContent';

export const useWealthSavingsHowToGetStartedContent = () =>
  useWealthSavingsSectionContent(parseWealthSavingsHowToGetStartedContent);
